import { PartAlternativeSimilarityEnum } from '@luminovo/api-contracts';
import { assertUnreachable } from '@luminovo/commons';
import { Tag } from '@luminovo/design-system';
import { transEnum } from '@luminovo/frontend-utils';

import { partAlternativeSimilarityTranslations } from '../../i18n';

export const SimilarityTag = ({ similarity }: { similarity: PartAlternativeSimilarityEnum }): JSX.Element => {
    const label = transEnum(similarity, partAlternativeSimilarityTranslations);
    switch (similarity) {
        case PartAlternativeSimilarityEnum.SuggestedBySupplier:
            return <Tag color="yellow" attention="low" label={label} />;
        case PartAlternativeSimilarityEnum.FormFitFunction:
            return <Tag color="green" attention="low" label={label} />;
        case PartAlternativeSimilarityEnum.Functional:
            return <Tag color="violet" attention="low" label={label} />;
        case PartAlternativeSimilarityEnum.UsedByOthers:
            return <Tag color="blue" attention="low" label={label} />;
        default:
            assertUnreachable(similarity);
    }
};
